import React from 'react';
import { Grid, useTheme } from '@mui/material';
import { KpiCard } from '../KpiCard/KpiCard';
import { KPITypesEnum } from '../../types';
import { DeviceFilterEnum } from '../FilterSection/DeviceSelector/types';
import { TimeRangeEnum } from '../FilterSection/TimeRangeSelector/types';

interface IKpiCardsContainerProps {
  timeRange?: TimeRangeEnum;
  product?: string;
  device?: DeviceFilterEnum;
  shopId: number;
}
export default function KpiCardsContainer({
  timeRange = TimeRangeEnum.Last1Month,
  product = 'All Syte Products',
  device = DeviceFilterEnum.AllDevices,
  shopId,
}: IKpiCardsContainerProps) {
  const theme = useTheme();
  const kpiTypes = Object.values(KPITypesEnum);

  return (
    <Grid container spacing={2}>
      {kpiTypes.map((kpi, index) => (
        <Grid
          key={index}
          item
          xs={12}
          sx={{
            [theme.breakpoints.down(1050)]: {
              flexBasis: '100%',
              maxWidth: '60%',
            },
            [theme.breakpoints.between(1050, 1150)]: {
              flexBasis: '50%',
              maxWidth: '45%',
            },
            [theme.breakpoints.up(1150)]: {
              flexBasis: '33.33%',
              maxWidth: '33.33%',
            },
          }}
        >
          <KpiCard
            kpiType={kpi}
            timeRange={timeRange}
            product={product}
            device={device}
            shopId={shopId}
          />
        </Grid>
      ))}
    </Grid>
  );
}
